<template>
  <div id="publications">
    <bread :content="breadContent"></bread>
    <p class="Page-title">学术论文</p>
    <el-divider></el-divider>
    <div class="container">
      <paperCard :data="item" v-for="(item, index) in paperCardData" :key="index"></paperCard>
    </div>
  </div>
</template>

<script>
import bread from '@/components/bread';
import paperCard from '@/components/studyResult/paperCard'
import Api from '@/network.js'

export default {
  name: 'publications',
  components: {
    paperCard,
    bread
  },
  data() {
    return {
      breadContent: [
        {text:'首页', routerName:'index'},
        {text:'研究成果', routerName:'studyResult'},
        {text:'学术论文', routerName:''},
      ],
      paperCardData: []
    }
  },
  methods: {
    setData(obj) {
      // 将obj与this.data合并
      Object.assign(this.$data, obj)
    }
  },
  async beforeRouteEnter (to, from, next) {
    const PER_COUNT = 4 
    const res = (await Api.studyResult.getAcademicPaper())||[];
    let data = [], sub = []
    res.forEach((item, index) => {
      sub.push({
        title: item.Title,
        authors: item.Author,
        publication: item.PublishInstitution,
        date: item.Date,
        id: item.Id
      })
      if (index % PER_COUNT === PER_COUNT - 1) {
        data.push(sub)
        sub = []
      }
    })
    if (res.length % PER_COUNT !== 0) {
      // 剩下未满 PER_COUNT 的数据
      data.push(sub)
    }
    next(vm => vm.setData({paperCardData: data}))
  },
  // async created() {
  //   this.paperCardData = data
  // },
}
</script>

<style lang="scss" scoped>
  #publications {
    width: calc(100% - 250px);
    margin-left: 50px;
    margin-top: 40px;
  }
  .container {
    display: flex;
    flex-wrap: wrap;
    padding-top: 10px;
    width: 100%;
    .paperCard {
      margin-bottom: 45px;
      cursor: pointer;
    }
  }
</style>
